import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "forgot-password"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "lead" };
const _hoisted_6 = { class: "bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'forgot_password_send',
    props: {
        common: {},
        email: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "パスワード再発行", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[0] || (_cache[0] = _createElementVNode("p", null, [
                                        _createTextVNode(" 入力されたメールアドレスで会員登録されている場合、"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" ご登録のメールアドレスにパスワード再発行アドレスをお送りしております。 ")
                                    ], -1)),
                                    _createElementVNode("p", null, _toDisplayString(props.email), 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
                                        _createTextVNode(" お届けしたメール内のURLリンクをクリックしてパスワード再発行を続けてください。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" まだパスワード再発行は完了しておりません。 ")
                                    ], -1))
                                ]),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w_sub" }, [
                                    _createElementVNode("p", null, [
                                        _createTextVNode(" ※メールに記載したURLリンクの有効期限は10分間です。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 有効期限が切れた場合は再度メールアドレスの入力を行ってください。 ")
                                    ]),
                                    _createElementVNode("p", null, [
                                        _createTextVNode(" ※メールが届かない場合"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 迷惑メールフォルダに振り分けられていることもありますのでご確認ください。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" また、「@sharementors.jp」ドメインの受信を可能に設定してください。 ")
                                    ])
                                ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(Link), {
                                    href: "/",
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("ホームに戻る")
                                    ])),
                                    _: 1,
                                    __: [3]
                                })
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
